var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "GmapMap",
    {
      ref: "mapRef",
      staticStyle: { width: "100%", height: "720px" },
      attrs: {
        options: _vm.options,
        center: _vm.center,
        zoom: _vm.zoom,
        "map-type-id": "roadmap"
      },
      on: {
        zoom_changed: function($event) {
          _vm.zoom = $event
        },
        click: function($event) {
          _vm.infoWinOpen = false
        }
      }
    },
    [
      _c("GmapInfoWindow", {
        attrs: {
          options: _vm.infoOptions,
          position: _vm.infoWindowPos,
          opened: _vm.infoWinOpen
        },
        on: {
          closeclick: function($event) {
            _vm.infoWinOpen = false
          }
        }
      }),
      _vm._v(" "),
      _vm._l(_vm.markers, function(m, index) {
        return _c("GmapMarker", {
          key: m.id + m.index,
          attrs: {
            position: m.position,
            icon: m.icon,
            zIndex: m.zIndex,
            label: m.label,
            clickable: true,
            draggable: false
          },
          on: {
            click: function($event) {
              return _vm.toggleInfoWindow(m, index)
            }
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }